<template>
  <Slick ref="slick" class="howitwork-carousel" :options="slickOptions">
    <div v-for="(item, index) in items" :key="index" class="carousel-container">
      <div class="card-container">
        <div class="info-container">
          <h4 class="card-heading">{{ item.title }}</h4>
          <p class="card-desc">{{ item.description }}</p>
          <a v-if="item.button && item.button.text" :href="item.button.url" target="_blank" class="btn-mb theme-button btn btn-primary text-white">{{ item.button.text }}</a>
        </div>
        <div class="w-100">
          <img v-if="item.image_url" v-img="{ type:'l', class: 'default-ratio' }" class="hiw_image" :src="item.image_url">
        </div>
      </div>
    </div>
  </Slick>

</template>

<script>
import Slick from 'vue-slick'
const $ = require('jquery')

export default {
  name: 'HowItWorkCarousel',
  components: {
    Slick
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      DEVELOPER_PORTAL_URL: '',
      slickOptions: {
        // infinite: false,
        initialSlide: 0,
        // useTransform: false,
        // transformAnimate: false,
        dots: true,
        dotsClass: 'api-carousel-dots',
        infinite: true,
        slidesToShow: 1,
        // adaptiveHeight: true,
        prevArrow: `<span class="fa fa-arrow-left slick-arrow slick-arrow-primary-white slick-arrow-left slick-arrow-centered-y shadow-soft rounded-circle ml-n3" />`,
        nextArrow: `<span class="fa fa-arrow-right slick-arrow slick-arrow-primary-white slick-arrow-right slick-arrow-centered-y shadow-soft rounded-circle mr-n3" />`
      }
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    },
    loggedIn() {
      return this.$store.getters.login
    },
    afterItems() {
      return this.items.length >= 3 ? this.items.slice(3, 9) : []
    },
    staticCardNum() {
      return this.items.length
    },
    calcCardNum() {
      return this.items.length
    }
  },
  watch: {
    items: {
      deep: true,
      handler() {}
    }
  },
  async created() {
  },
  beforeUpdate() {
    if (this.$refs.slick) {
      this.$refs.slick.destroy()
    }
  },
  updated() {
    this.$nextTick(function() {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions)
        //  We will simulate a click event for cloned API cards.
        $(document).find('.howitwork-carousel').on('click', e => {
          //  clickIndex returns their index computed by slick - but they are not always in a properly defined range.
          //  So we will get the raw index, then use modulo to find the properly defined index.
          const clickIndex = $(e.currentTarget).data('slickIndex')
          const itemIndex = (clickIndex % this.items.length + this.items.length) % this.items.length
          window.open(this.items[itemIndex].button.url, '_blank')
        })
      }
    })
  },
  methods: {
    afterChange() {
      this.$nextTick(function() {
        if (this.$refs.slick) {
          $(document).find('.howitwork-carousel').on('click', e => {
          //  clickIndex returns their index computed by slick - but they are not always in a properly defined range.
          //  So we will get the raw index, then use modulo to find the properly defined index.
            const clickIndex = $(e.currentTarget).data('slickIndex')
            const itemIndex = (clickIndex % this.items.length + this.items.length) % this.items.length
            window.open(this.items[itemIndex].button.url, '_blank')
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~slick-carousel/slick/slick.css';
@import '~slick-carousel/slick/slick-theme.css';
.btn-mb{
  margin-bottom: 16px;
}
.carousel-container{
  // margin-right: 5px;
  // margin-left: 5px;
  // border-radius: 5px;
  // background-color: #FFFFFF;
  // box-shadow: 0 4px 12px 0 rgba(0,0,0,0.08);
  // margin-bottom: 12px;
  // margin-top: 1px;
  // padding:48px;
}
.info-container {
  min-width: 50%;
}
.card-heading{
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 33px;
}
.card-desc{
  font-size: 16px;
  letter-spacing: 0;
  line-height: 25px;
  margin-top:8px;
  margin-bottom:32px;
}
.howitwork-carousel {
  width: 100%;
}
.card-container{
  display:flex;
  margin: 1px 10px 12px 10px;
  border-radius: 5px;
  background-color: #FFFFFF;
  box-shadow: 0 4px 12px 0 rgba(0,0,0,0.08);
  padding:48px;
  // align-items: center;
}
.hiw_image{
    width: 492px;
}
@media screen and (max-width: 992px) {
  w-100{
    width:100%;
  }
  .info-container {
    min-width: 0px;
  }
  .card-container{
    flex-direction:column;
  }
  .hiw_image{
    width:100%;
  }
}
@media (max-width: 575.98px) {
  .carousel-container {
    padding: 24px;
  }
}
</style>
